/**
 * Scheduled capture share button utility.
 * Computes the current 2-hour slot URL and shows a Ghost-style share modal.
 *
 * Slots: 09, 11, 13, 15, 17, 19, 21, 23 (UTC hours).
 * If before 09:00 UTC, uses slot 23 from the previous day.
 */
(function () {
    var CDN   = 'https://images.pollingreport.uk/captures/scheduled';
    var SLOTS = [9, 11, 13, 15, 17, 19, 21, 23];

    function pad2(n) { return n < 10 ? '0' + n : String(n); }

    function currentSlot() {
        var now = new Date(), utcHour = now.getUTCHours(), dateStr, slot;
        if (utcHour < SLOTS[0]) {
            var prev = new Date(now);
            prev.setUTCDate(prev.getUTCDate() - 1);
            dateStr = prev.getUTCFullYear() + '-' + pad2(prev.getUTCMonth() + 1) + '-' + pad2(prev.getUTCDate());
            slot = SLOTS[SLOTS.length - 1];
        } else {
            dateStr = now.getUTCFullYear() + '-' + pad2(now.getUTCMonth() + 1) + '-' + pad2(now.getUTCDate());
            slot = SLOTS[0];
            for (var i = SLOTS.length - 1; i >= 0; i--) {
                if (utcHour >= SLOTS[i]) { slot = SLOTS[i]; break; }
            }
        }
        return { date: dateStr, hour: pad2(slot) };
    }

    function slotImageUrl(type) {
        var staticCaptureMap = {
            projection: 'og/projection-png.png',
            results: 'og/results-png.png',
            'seats-chart': 'og/seats-chart-png.png',
            'polls-latest': 'og/polls-latest-png.png',
            'polls-chart': 'og/polls-chart-png.png',
            poll: 'og/poll-png.png'
        };

        if (staticCaptureMap[type]) {
            return CDN + '/' + staticCaptureMap[type];
        }

        // Legacy fallback for older scheduled naming.
        var s = currentSlot();
        return CDN + '/' + type + '-' + s.date + '-' + s.hour + '.webp';
    }

    var ICON_X     = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.261 5.632 5.903-5.632zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>';
    var ICON_LI    = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>';
    var ICON_MAIL  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>';
    var ICON_MORE  = '<svg viewBox="0 0 24 24" fill="currentColor"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg>';
    var ICON_LINK  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>';
    var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

    var activeModal = null;

    function closeModal() {
        if (activeModal) { activeModal.remove(); activeModal = null; }
    }

    function getOgImage() {
        var el = document.querySelector('meta[property="og:image"]') || document.querySelector('meta[name="twitter:image"]');
        return (el && el.getAttribute('content')) || '';
    }

    function showShareModal(type, text, canonicalUrl, imageOverride) {
        closeModal();

        var pageUrl  = (canonicalUrl || window.location.href).split('#')[0];
        var currentUrl = window.location.href.split('#')[0];
        var ogFallback = (pageUrl === currentUrl) ? getOgImage() : '';
        var imageUrl = imageOverride || slotImageUrl(type);
        var tweetText = 'Latest general election predictions based on current opinion polling\n\n' + pageUrl;
        var tweetUrl = 'https://x.com/intent/tweet?text=' + encodeURIComponent(tweetText);
        var liUrl    = 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(pageUrl);
        var mailUrl  = 'mailto:?subject=' + encodeURIComponent(text) + '&body=' + encodeURIComponent(text + '\n\n' + imageUrl);

        var overlay = document.createElement('div');
        overlay.className = 'ukpr-share-overlay';

        var modal = document.createElement('div');
        modal.className = 'ukpr-share-modal';
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-label', 'Share');

        modal.innerHTML =
            '<div class="ukpr-share-modal-header">' +
                '<span class="ukpr-share-modal-title">Share</span>' +
            '</div>' +
            '<button class="ukpr-share-modal-close" aria-label="Close">' + ICON_CLOSE + '</button>' +
            '<div class="ukpr-share-modal-preview">' +
                '<img class="ukpr-share-preview-img" src="' + imageUrl + '" alt="" loading="eager">' +
                '<div class="ukpr-share-preview-content">' +
                    '<h2 class="ukpr-share-preview-title">' + text + '</h2>' +
                    '<div class="ukpr-share-preview-footer">' +
                        '<img class="ukpr-share-preview-favicon" src="https://pollingreport.uk/favicon.ico" alt="" aria-hidden="true">' +
                        '<div class="ukpr-share-preview-meta">UK Polling Report</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="ukpr-share-modal-actions">' +
                '<button class="ukpr-share-action copy" data-copy-url="' + pageUrl + '">' +
                    ICON_LINK + '<span>Copy link</span>' +
                '</button>' +
                '<a class="ukpr-share-action" href="' + tweetUrl + '" target="_blank" rel="noopener" aria-label="Post on X">' + ICON_X + '</a>' +
                '<a class="ukpr-share-action" href="' + liUrl + '" target="_blank" rel="noopener" aria-label="Share on LinkedIn">' + ICON_LI + '</a>' +
                '<a class="ukpr-share-action" href="' + mailUrl + '" aria-label="Share by email">' + ICON_MAIL + '</a>' +
                (navigator.share ? '<button class="ukpr-share-action" data-share-native aria-label="More">' + ICON_MORE + '</button>' : '') +
            '</div>';

        overlay.appendChild(modal);
        document.body.appendChild(overlay);
        activeModal = overlay;

        overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
        modal.querySelector('.ukpr-share-modal-close').addEventListener('click', closeModal);

        modal.querySelector('[data-copy-url]').addEventListener('click', function () {
            var url = this.getAttribute('data-copy-url');
            var span = this.querySelector('span');
            var finish = function () { if (span) span.textContent = 'Copied!'; setTimeout(closeModal, 1400); };            if (navigator.clipboard) { navigator.clipboard.writeText(url).then(finish); }
            else { var ta = document.createElement('textarea'); ta.value = url; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); ta.remove(); finish(); }
        });

        var nativeBtn = modal.querySelector('[data-share-native]');
        if (nativeBtn) {
            nativeBtn.addEventListener('click', function () { closeModal(); navigator.share({ title: text, url: pageUrl }); });
        }

        var img = modal.querySelector('.ukpr-share-preview-img');
        img.addEventListener('error', function () {
            if (ogFallback && img.src !== ogFallback) {
                img.src = ogFallback;
            } else {
                img.style.display = 'none';
            }
        });

        function onKey(e) { if (e.key === 'Escape') { closeModal(); document.removeEventListener('keydown', onKey); } }
        document.addEventListener('keydown', onKey);
    }

    document.addEventListener('DOMContentLoaded', function () {
        document.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-share-capture]');
            if (!btn) return;
            e.preventDefault();
            e.stopPropagation();
            showShareModal(
                btn.getAttribute('data-share-capture'),
                btn.getAttribute('data-share-text') || 'UK Polling Report',
                btn.getAttribute('data-share-url') || null,
                btn.getAttribute('data-share-image') || null
            );
        });
    });

    window.UKPRShare = { slotImageUrl: slotImageUrl, showShareModal: showShareModal };
})();
